import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index.js";
/*
 |--------------------------------------------------------------------------
 | Admin Views
 |--------------------------------------------------------------------------|
 */

// Layouts
import LayoutBasic from "./views/layouts/LayoutBasic.vue";
import LayoutLogin from "./views/layouts/LayoutLogin.vue";
import LayoutWizard from "./views/layouts/LayoutWizard.vue";
import AdminLayoutBasic from "./views/layouts/AdminLayoutBasic.vue";
import AnchorLayoutBasic from "./views/layouts/AnchorLayoutBasic.vue";
import FunderLayoutBasic from "./views/layouts/FunderLayoutBasic.vue";
import AuditorLayoutBasic from "./views/layouts/AuditorLayoutBasic.vue";
import {
  isFunder,
  isAuditor,
  isAnchor,
  isAdmin,
  isSuperAdmin,
  isPasswordReset
} from "./middleware/auth";
import multiguard from "vue-router-multiguard";
// Auth
import Login from "./views/auth/Login.vue";
import OtpVerification from "./views/auth/OtpVerification.vue";
import VerifyEmail from "./views/auth/VerifyEmail.vue";
import VerifiedEmail from "./views/auth/VerifiedEmail.vue";
import ForgotPassword from "./views/auth/ForgotPassword.vue";
import ResetPassword from "./views/auth/ResetPassword.vue";
import Register from "./views/auth/Register.vue";

import NotFoundPage from "./views/errors/404.vue";

/*
 |--------------------------------------------------------------------------
 | Admin Views
 |--------------------------------------------------------------------------|
 */

// Dashbord
import Dashboard from "./views/dashboard/Dashboard.vue";
import SuperAdminDashboard from "./views/dashboard/SuperAdminDashboard.vue";
import AnchorDashboard from "./views/dashboard/AnchorDashboard.vue";
import FunderDashboard from "./views/dashboard/FunderDashboard.vue";
import AuditorDashboard from "./views/dashboard/AuditorDashboard.vue";

// Backup
import BackupIndex from "./views/backup/index.vue";

// Emails
import EmailTemplateIndex from './views/emailTemplates/Index.vue'
import EmailTemplateCreate from './views/emailTemplates/Create.vue'

import ActionIndex from "./views/emailActionList/Index.vue";
import ActionPlaceholders from "./views/emailActionList/Placeholders.vue";
// Finances Forms
import FinancesFormsIndex from "./views/financesForms/Index.vue";
import FinancesFunderFormsList from "./views/financesForms/FunderFormsList.vue";
import FinancesFormsCreate from "./views/financesForms/Create.vue";
// Communication
import communicationIndex from "./views/communications/Index.vue";
import communicationCreate from "./views/communications/Create.vue";
// Accounts
import AccountIndex from "./views/accounts/Index.vue";
import AccountCreate from "./views/accounts/Create.vue";
import AccountView from "./views/accounts/view/layout/Index.vue";
import AccountBasicInfo from "./views/accounts/view/BasicInfo.vue";
import AccountCompanyAddress from "./views/accounts/view/CompanyAddress.vue";
import AccountBillingAddress from "./views/accounts/view/BillingAddress.vue";
import AccountShippingAddress from "./views/accounts/view/ShippingAddress.vue";
import ConnectAuditorAccount from "./views/accounts/view/ConnectAuditorAccount.vue";
import ConnectFormAccount from "./views/accounts/view/ConnectFormAccount.vue";
import PanelInfo from "./views/accounts/PanelInfo.vue";

import PasswordReset from "./views/password/Index.vue";
// Customers
import CustomerIndex from "./views/customers/Index.vue";
import CustomerCreate from "./views/customers/Create.vue";
import CustomerView from "./views/customers/view/layout/Index.vue";
import CustomerBasicInfo from "./views/customers/view/BasicInfo.vue";
import CustomerBillingAddress from "./views/customers/view/BillingAddress.vue";
import CustomerShippingAddress from "./views/customers/view/ShippingAddress.vue";
import CustomerBusinessStatus from "./views/customers/view/BusinessStatus.vue";
import CustomerBorrowerProfile from "./views/customers/view/BorrowerProfile.vue";
import CustomerStakeholder from "./views/customers/view/Stakeholder.vue";
import CustomerBusinessFinancialInstitutions from "./views/customers/view/BusinessFinancialInstitutions.vue";
import CustomerFinancialFacilities from "./views/customers/view/FinancialFacilities.vue";
import CustomerReschedulingRestructuring from "./views/customers/view/ReschedulingRestructuring.vue";
import CustomerDocuments from "./views/customers/view/Documents.vue";
import InternalProcess from "./views/customers/view/InternalProcess.vue";
import CustomerProcess from "./views/customers/view/CustomerProcess.vue";
import ProcessDocuments from "./views/customers/view/ProcessDocument.vue";

// islamic finance
import IslamicFinanceIndex from "./views/islamicFinance/Index.vue";
import IslamicFinanceRecord from "./views/islamicFinance/Records.vue";
import IslamicFinanceAttachment from "./views/islamicFinance/Attachment.vue";
import OfferToSellCreate from "./views/islamicFinance/offerToSell/Create.vue";
import IslamicFinanceInvoiceInfo from "./views/islamicFinance/InvoiceInfo.vue";
import IslamicFinanceInvoiceVerification from "./views/islamicFinance/InvoiceVerification.vue";

// supplier
import SupplierIndex from "./views/suppliers/Index.vue";
import SupplierCreate from "./views/suppliers/Create.vue";
import SupplierView from "./views/suppliers/view/layout/Index.vue";
import SupplierBasicInfo from "./views/suppliers/view/BasicInfo.vue";
import SupplierBillingAddress from "./views/suppliers/view/BillingAddress.vue";
import SupplierShippingAddress from "./views/suppliers/view/ShippingAddress.vue";
import SupplierProcess from "./views/suppliers/view/Process.vue";

// funder
import FunderIndex from "./views/funders/Index.vue";
import FunderView from "./views/funders/view/layout/Index.vue";
import FunderBasicInfo from "./views/funders/view/BasicInfo.vue";
import FunderBillingAddress from "./views/funders/view/BillingAddress.vue";
import FunderShippingAddress from "./views/funders/view/ShippingAddress.vue";
import FunderCreditLimit from "./views/funders/view/CreditLimit.vue";
// import FunderFinance from './views/funders/islamicFinance/IslamicFinance.vue'
// import FunderFinanceRecord from './views/funders/islamicFinance/Record.vue'

// Items
import ItemsIndex from "./views/items/Index.vue";
import ItemCreate from "./views/items/Create.vue";

// Invoices
import InvoiceIndex from "./views/invoices/Index.vue";
import InvoiceCreate from "./views/invoices/Create.vue";
import ManualInvoiceCreate from "./views/invoices/Create1.vue";
import InvoiceView from "./views/invoices/View.vue";
import SelectFunder from "./views/invoices/Funder.vue";
import InvoiceActionRecord from "./views/invoices/Records.vue";
import InvoiceDiscrepencyReport from "./views/invoices/DiscrepencyReport.vue";
import ChangePromisedDate from "./views/prepayments/ChangePromisedDate.vue";

// PreapprovedInvoices
import PreapprovedInvoiceIndex from "./views/preapprovedInvoices/Index.vue";
import BulkProcessing from "./views/preapprovedInvoices/BulkProcessing.vue";

import PreapprovedInvoices from "./views/preapprovedInvoices/Attachment.vue";

// Payments
import PaymentsIndex from "./views/payments/Index.vue";
// anchor create
import AnchorPaymentCreate from "./views/payments/Anchor.vue";
import PaymentView from "./views/payments/View.vue";
import FunderPaymentCreate from "./views/payments/Funder.vue";
import POFunderPaymentCreate from "./views/payments/POFunder.vue";
import AdminPaymentCreate from "./views/payments/Supplier.vue";
import PaymentRecord from "./views/payments/Records.vue";
// Attachment
import InvoiceAttachment from "./views/invoices/Attachment.vue";

// PrePayment
import PrePaymentCreate from "./views/prepayments/Create.vue";
import PrePaymentProcessing from "./views/prepayments/Processing.vue";
import PrePaymentOffer from "./views/prepayments/Offer.vue";
import PrePaymentRequest from "./views/prepayments/Request.vue";
import PrePaymentView from "./views/prepayments/View.vue";
import PrepaymentVerifiedPage from "./views/prepayments/Verified.vue";
import PrepaymentApprovedPage from "./views/prepayments/Approved.vue";
import PrepaymentPendingPage from "./views/prepayments/Pending.vue";

// Estimates
import EstimateIndex from "./views/estimates/Index.vue";
import EstimateCreate from "./views/estimates/Create.vue";
import EstimateView from "./views/estimates/View.vue";

// user managements
import UserManagementIndex from "./views/userManagements/Index.vue";
import UserManagementCreate from "./views/userManagements/Create.vue";

// PO
import POIndex from "./views/po/Index.vue";
import POCreate from "./views/po/Create.vue";
import POView from "./views/po/View.vue";
import POAttachment from "./views/po/Attachment.vue";
import POItemStatus from "./views/po/ItemStatus.vue";
import PODiscrepencyReport from "./views/po/DiscrepencyReport.vue";
import POFinancingActionRecord from "./views/po/Records.vue";
import POFinancingRequest from "./views/po/Request.vue";
import POFinancingIndex from "./views/po/FinancingIndex.vue";
import POFinancingPendingPage from "./views/po/Pending.vue";
import POFinancingOfferPage from "./views/po/Offer.vue";
import POPrePaymentView from "./views/po/POPrePaymentView.vue";
import SelectPOFunder from "./views/po/Funder.vue";
import POPrepaymentVerifiedPage from "./views/po/Verified.vue";
// Delivery Note
import DeliveryNoteIndex from "./views/deliveryNotes/Index.vue";
import DeliveryNoteCreate from "./views/deliveryNotes/Create.vue";
import ManualDeliveryNoteCreate from "./views/deliveryNotes/Create1.vue";
import DeliveryNoteView from "./views/deliveryNotes/View.vue";

// Expenses
import ExpensesIndex from "./views/expenses/Index";
import ExpenseCreate from "./views/expenses/Create.vue";

// Report
import InvoicesReport from "./views/reports/InvoicesReport.vue";
import InvoiceReport from "./views/reports/InvoiceReport.vue";
import PreapprovedInvoiceReport from "./views/reports/PreapprovedInvoiceReport.vue";
import DisbursementReport from "./views/reports/DisbursementReport.vue";
import PaymentReport from "./views/reports/PaymentReport.vue";
import PaymentOutstandingReport from "./views/reports/PaymentOutstandingReport.vue";
import OnTimePaymentReport from "./views/reports/OnTimePaymentReport.vue";
import PaymentReciptReport from "./views/reports/PaymentReciptReport.vue";
import PurchasesReport from "./views/reports/PurchasesReport.vue";
import SalesReport from "./views/reports/SalesReports";
import SalesDataReport from "./views/reports/SalesDataReport.vue";
import ApprovedFinanceReport from "./views/reports/ApprovedFinanceReport"
import ProfitShareReport from "./views/reports/ProfitShareReport";
import ExpensesReport from "./views/reports/ExpensesReport";
import ProfitLossReport from "./views/reports/ProfitLossReport";
import TaxReport from "./views/reports/TaxReport.vue";
import ReportLayout from "./views/reports/layout/Index.vue";
import AnchorReportLayout from "./views/reports/layout/AnchorReportLayoutIndex.vue";
import FunderReportLayout from "./views/reports/layout/FunderReportLayoutIndex.vue";
import SuperAdminReportLayout from "./views/reports/layout/SuperAdminReportLayoutIndex.vue";

// Data Export
import PurchaseOrderDataExport from "./views/dataExports/PurchaseOrderDataExport.vue";
import InvoiceDataExport from "./views/dataExports/InvoiceDataExport.vue";
import InvoiceDetailDataExport from "./views/dataExports/InvoiceDetailDataExport.vue";
import PaymentDataExport from "./views/dataExports/PaymentDataExport.vue";
import ReportDataExport from "./views/dataExports/ReportDataExport.vue";
import DataExportLayout from "./views/dataExports/layout/Index.vue";
import FunderDataExportLayout from "./views/dataExports/layout/FunderDataExportLayout.vue";
import AnchorDataExportLayout from "./views/dataExports/layout/AnchorDataExportLayout.vue";

// Profile
import ProfileLayout from "./views/profile/layout/Index.vue";
import BusinessStatus from "./views/profile/BusinessStatus.vue";
import BorrowerProfile from "./views/profile/BorrowerProfile.vue";
import BusinessNature from "./views/profile/BusinessNature.vue";
import BusinessFinancialInstitutions from "./views/profile/BusinessFinancialInstitutions.vue";
import FinancialFacilities from "./views/profile/FinancialFacilities.vue";
import ReschedulingRestructuring from "./views/profile/ReschedulingRestructuring.vue";
import stakeholder from "./views/profile/stakeholder.vue";
import Documents from "./views/profile/Documents.vue";
import SharingProfileCode from "./views/profile/SharingProfileCode.vue";
// Settings
import SettingsLayout from "./views/settings/layout/Index.vue";
import SuperAdminSettingsLayout from "./views/settings/layout/AdminSettingLayout.vue";
import AnchorSettingLayout from "./views/settings/layout/AnchorSettingLayout.vue";
import FunderSettingLayout from "./views/settings/layout/FunderSettingLayout.vue";
import CompanyInfo from "./views/settings/CompanyInfo.vue";
import Addresses from "./views/settings/Addresses.vue";
import Customization from "./views/settings/Customization.vue";
import Notifications from "./views/settings/Notifications.vue";
import Preferences from "./views/settings/Preferences.vue";
import UserProfile from "./views/settings/UserProfile.vue";
import AdminProfile from "./views/settings/AdminProfile.vue";
import TaxTypes from "./views/settings/TaxTypes.vue";
import ExpenseCategory from "./views/settings/ExpenseCategory.vue";
import MailConfig from "./views/settings/MailConfig.vue";
import UpdateApp from "./views/settings/UpdateApp.vue";
import Contacts from "./views/settings/Contacts.vue";
import Wizard from "./views/wizard/Index.vue";
import PasswordResetLayout from "./views/layouts/PasswordResetLayout";
import CurrencySetting from "./views/settings/CurrencySetting.vue";
import DocumentTypeSetting from "./views/settings/DocumentTypeSetting.vue";
import UserGuideIndex from "./views/userGuides/Index.vue";
import IslamicFinanceFormTemplates from "./views/islamicFinanceForms/Index.vue";
import UserGuideView from "./views/userGuides/View.vue";
import IslamicFinanceForm from "./views/settings/IslamicFinanceForm.vue";
Vue.use(VueRouter);

const routes = [
  /*
   |--------------------------------------------------------------------------
   | Frontend Routes
   |--------------------------------------------------------------------------|
   */

  /*
   |--------------------------------------------------------------------------
   | Auth & Registration Routes
   |--------------------------------------------------------------------------|
   */

  {
    path: "/",
    component: LayoutLogin,
    meta: { redirectIfAuthenticated: true },
    children: [
      {
        path: "/",
        component: Login
      },
      {
        path: "login",
        component: Login,
        name: "login"
      },
      // {
      //   path: '/otp-verification/:id',
      //   component: OtpVerification,
      //   name: 'otpVerification'
      // },
      {
        path: "/otp-verification/:id",
        component: OtpVerification,
        name: "otpVerification"
      },
      {
        path: "verify-email",
        component: VerifyEmail,
        name: "verifyEmail"
      },
      {
        path: "email-verified",
        component: VerifiedEmail,
        name: "verifiedEmail"
      },
      {
        path: "/forgot-password",
        component: ForgotPassword,
        name: "forgot-password"
      },
      {
        path: "/reset-password/:token",
        component: ResetPassword,
        name: "reset-password"
      },
      {
        path: "register",
        component: Register,
        name: "register"
      }
    ]
  },

  /*
   |--------------------------------------------------------------------------
   | Onboarding Routes
   |--------------------------------------------------------------------------|
   */
  {
    path: "/on-boarding",
    component: LayoutWizard,
    children: [
      {
        path: "/",
        component: Wizard,
        name: "wizard"
      }
    ]
  },
  /*
  |--------------------------------------------------------------------------
  | Auditor Backend Routes
  |--------------------------------------------------------------------------|
  */
  {
    path: "/auditor",
    component: AuditorLayoutBasic, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      {
        path: "/",
        component: AuditorDashboard,
        name: "Auditor-dashboard",
        beforeEnter: multiguard([isAuditor])
      },
      {
        path: "dashboard",
        component: AuditorDashboard,
        beforeEnter: multiguard([isAuditor])
      },
      {
        path: "islamic-finances",
        component: IslamicFinanceIndex,
        beforeEnter: multiguard([isAuditor])
      },
      {
        path: "islamic-finances/:id/record",
        component: IslamicFinanceRecord,
        beforeEnter: multiguard([isAuditor])
      }
    ]
  },
  /*
  |--------------------------------------------------------------------------
  | Funder Backend Routes
  |--------------------------------------------------------------------------|
  */
  {
    path: "/funder",
    component: PasswordResetLayout, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Password Change
      {
        path: "password/reset",
        component: PasswordReset,
        beforeEnter: multiguard([isAdmin])
      }
    ]
  },
  {
    path: "/funder",
    component: FunderLayoutBasic, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // funder-Dashboard
      {
        path: "/",
        component: FunderDashboard,
        name: "funder-dashboard",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "dashboard",
        component: FunderDashboard,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "user-guides",
        component: UserGuideView,
        name: "funder-default-userGuide",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "user-guides/:id/view",
        component: UserGuideView,
        name: "funder-specfic-userGuide",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "islamic-finances",
        component: IslamicFinanceIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "islamic-finances/:id/attachments",
        component: IslamicFinanceAttachment,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "islamic-finances/:id/record",
        component: IslamicFinanceRecord,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "clients",
        component: CustomerIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "clients/:id/view",
        component: CustomerView,
        beforeEnter: multiguard([isFunder, isPasswordReset]),
        children: [
          {
            path: "basic-info",
            component: CustomerBasicInfo
          },
          {
            path: "billing-address",
            component: CustomerBillingAddress
          },
          {
            path: "shipping-address",
            component: CustomerShippingAddress
          },
          {
            path: "business-status",
            component: CustomerBusinessStatus
          },
          {
            path: "borrower-profile",
            component: CustomerBorrowerProfile
          },
          {
            path: "stakeholder",
            component: CustomerStakeholder
          },
          {
            path: "business_financial_institutions",
            component: CustomerBusinessFinancialInstitutions
          },
          {
            path: "financial_facilities",
            component: CustomerFinancialFacilities
          },
          {
            path: "rescheduling_restructuring",
            component: CustomerReschedulingRestructuring
          },
          {
            path: "documents",
            component: CustomerDocuments
          },
          {
            path: "internal-process",
            component: InternalProcess
          },
          {
            path: "customer-process",
            component: CustomerProcess
          },
          {
            path: "processs-documents",
            component: ProcessDocuments
          }
        ]
      },
      {
        path: "user-managements",
        component: UserManagementIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "user-managements/create",
        component: UserManagementCreate,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "user-managements/:id/edit",
        component: UserManagementCreate,
        name: "funder-user-management.edit",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },

      {
        path: "customers",
        component: CustomerIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "invoices",
        component: InvoiceIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },

      {
        path: "preapproved-invoices",
        component: PreapprovedInvoiceIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },

      {
        path: "invoices/:id/view",
        component: InvoiceView,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "invoices/:id/attachment",
        component: InvoiceAttachment,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "invoices/:id/record",
        component: InvoiceActionRecord,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "purchaseorder-financing",
        component: POIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "purchaseorder-financing/:id/pending",
        component: POFinancingPendingPage,
        name: "purchaseorder.financing.pending",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "purchaseorder-financing/:id/offer",
        component: POFinancingOfferPage,
        name: "purchaseorder.financing.offer",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "purchaseorder-financing/:id/record",
        component: POFinancingActionRecord,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "purchaseorder-financing/:id/view",
        component: POView,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchaseorder-financing/:id/attachment",
        component: POAttachment,
        beforeEnter: multiguard([isSuperAdmin])
      },
      // payments
      {
        path: "payments",
        name: "funder.payments.index",
        component: PaymentsIndex,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "payments/:id/view",
        component: PaymentView,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },

      {
        path: "payments/:id/record",
        component: PaymentRecord,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "payments/create",
        name: "funder.payments.create",
        component: FunderPaymentCreate,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "payments/:id/prepayment/create",
        name: "payments.prepayment.create",
        component: FunderPaymentCreate,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "payments/:id/po-prepayment/create",
        name: "payments.po-prepayment.create",
        component: POFunderPaymentCreate,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "payments/:id/settlement/create",
        name: "payments.settlement.create",
        component: FunderPaymentCreate,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "payments/:id/po-settlement/create",
        name: "payments.po-settlement.create",
        component: POFunderPaymentCreate,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      // prepayment
      {
        path: "prepayments/:id/create",
        component: PrePaymentCreate,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "prepayments/:id/view",
        component: PrePaymentView,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "preapproved/prepayments/:id/view",
        component: PrePaymentView,
        name: "preapproved-invoice-request-view-funder",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "prepayments/:id/processing",
        name: "prepayments.processing",
        component: PrePaymentProcessing,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "prepayments/:id/request",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },

      {
        path: "prepayments/:id/updateRequest",
        name: "prepayments.updateRequest.funder",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "prepayments/:id/pending",
        component: PrepaymentPendingPage,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "preapproved/prepayments/:id/pending",
        component: PrepaymentPendingPage,
        name: "preapproved.invoice.pending",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "prepayments/:id/offer",
        component: PrePaymentOffer,
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      {
        path: "preapproved/prepayments/:id/offer",
        component: PrePaymentOffer,
        name: "preapproved.invoice.offer",
        beforeEnter: multiguard([isFunder, isPasswordReset])
      },
      // Reports
      {
        path: "reports",
        component: FunderReportLayout,
        beforeEnter: multiguard([isFunder, isPasswordReset]),
        children: [
          {
            path: "invoices",
            component: InvoicesReport
          },
          {
            path: "disbursement-report",
            component: DisbursementReport
          },
          {
            path: "payment-outstanding-report",
            component: PaymentOutstandingReport
          },
          {
            path: "taxes",
            component: TaxReport
          },
          {
            path: "invoice-report",
            component: InvoiceReport
          },
          {
            path: "preapprovedInvoice-report",
            component: PreapprovedInvoiceReport
          },
          {
            path: "on-time-payment-report",
            component: OnTimePaymentReport
          },
          {
            path: "approved-finance",
            component: ApprovedFinanceReport
          },
          {
            path: "profit-share-report",
            component: ProfitShareReport
          }
        ]
      },

      // Data Export
      {
        path: "data-exports",
        component: FunderDataExportLayout,
        beforeEnter: multiguard([isFunder, isPasswordReset]),
        children: [
          {
            path: "invoices",
            component: InvoiceDataExport
          },
          {
            path: "invoice-detail",
            component: InvoiceDetailDataExport
          },
          {
            path: "payments",
            component: PaymentDataExport
          },
          {
            path: "reports",
            component: ReportDataExport
          }
        ]
      },
      {
        path: "settings",
        component: FunderSettingLayout,
        beforeEnter: multiguard([isFunder, isPasswordReset]),
        children: [
          {
            path: "user-profile",
            component: AdminProfile
          },
          {
            path: "company-info",
            component: CompanyInfo
          },
          {
            path: "contacts",
            component: Contacts
          },
          {
            path: "customization",
            component: Customization
          },
          {
            path: "preferences",
            component: Preferences
          },
          {
            path: "forms",
            name: "islamicFinanceForm",
            component: IslamicFinanceForm
          }
        ]
      }
    ]
  },
  /*
  |--------------------------------------------------------------------------
  | Anchor Backend Routes
  |--------------------------------------------------------------------------|
  */
  {
    path: "/anchor",
    component: PasswordResetLayout, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Password Change
      {
        path: "password/reset",
        component: PasswordReset,
        beforeEnter: multiguard([isAnchor])
      }
    ]
  },
  {
    path: "/anchor",
    component: AnchorLayoutBasic, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Anchor-Dashboard
      {
        path: "/",
        component: AnchorDashboard,
        name: "anchor-dashboard",
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "dashboard",
        component: AnchorDashboard,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "user-guides",
        component: UserGuideView,
        name: "anchor-default-userGuide",
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "user-guides/:id/view",
        component: UserGuideView,
        name: "anchor-specfic-userGuide",
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "suppliers",
        component: SupplierIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "suppliers/create",
        component: SupplierCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "suppliers/:id/view",
        component: SupplierView,
        beforeEnter: multiguard([isAnchor, isPasswordReset]),
        children: [
          {
            path: "basic-info",
            component: SupplierBasicInfo
          },
          {
            path: "billing-address",
            component: SupplierBillingAddress
          },
          {
            path: "shipping-address",
            component: SupplierShippingAddress
          },
          {
            path: "supplier-process",
            component: SupplierProcess
          }
        ]
      },
      // user management
      {
        path: "user-managements",
        component: UserManagementIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "user-managements/create",
        component: UserManagementCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "user-managements/:id/edit",
        component: UserManagementCreate,
        name: "anchor-user-management.edit",
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "customers",
        component: CustomerIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "customers/:id/view",
        component: CustomerView,
        beforeEnter: multiguard([isAnchor, isPasswordReset]),
        children: [
          {
            path: "basic-info",
            component: CustomerBasicInfo
          },
          {
            path: "billing-address",
            component: CustomerBillingAddress
          },
          {
            path: "shipping-address",
            component: CustomerShippingAddress
          }
        ]
      },
      {
        path: "items",
        component: ItemsIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "items/create",
        name: "anchor.items.create",
        component: ItemCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "items/:id/edit",
        name: "anchor.items.edit",
        component: ItemCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      // PrePayment
      {
        path: "prepayments/:id/request",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },

      {
        path: "prepayments/:id/approved",
        component: PrepaymentApprovedPage,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "prepayments/:id/updateRequest",
        name: "prepayments.updateRequest.anchor",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "prepayments/:id/view",
        component: PrePaymentView,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "preapproved/prepayments/:id/view",
        component: PrePaymentView,
        name: "preapproved-invoice-request-view-anchor",
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },

      {
        path: "prepayments/:id/offer",
        component: PrePaymentOffer,
        beforeEnter: multiguard([isAnchor], isPasswordReset)
      },
      {
        path: "preapproved/prepayments/:id/offer",
        component: PrePaymentOffer,
        name: "preapproved.invoice.offer",
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },

      // payments
      {
        path: "payments",
        name: "anchor.payments.index",
        component: PaymentsIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "payments/:id/record",
        component: PaymentRecord,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "payments/:id/view",
        component: PaymentView,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "payments/:id/create",
        name: "anchor.invoice.payments.create",
        component: AnchorPaymentCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "payments/create",
        name: "anchor.payments.create",
        component: AnchorPaymentCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "delivery-notes",
        component: DeliveryNoteIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "delivery-notes/:id/view",
        component: DeliveryNoteView,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "preapproved-invoices",
        component: PreapprovedInvoiceIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "preapproved-invoices/:id/attachment",
        component: PreapprovedInvoices,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "invoices",
        component: InvoiceIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "invoices/:id/view",
        component: InvoiceView,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "invoices/:id/record",
        component: InvoiceActionRecord,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "invoices/:id/attachment",
        component: InvoiceAttachment,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "invoices/:id/discrepency_report",
        component: InvoiceDiscrepencyReport,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },

      {
        path: "purchase-orders",
        component: POIndex,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "purchase-orders/create",
        name: "purchase-orders.create",
        component: POCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/view",
        component: POView,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/edit",
        name: "purchase-orders.edit",
        component: POCreate,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/item-status",
        component: POItemStatus,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/attachment",
        component: POAttachment,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/discrepency_report",
        component: PODiscrepencyReport,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/record",
        component: POFinancingActionRecord,
        beforeEnter: multiguard([isAnchor, isPasswordReset])
      },

      // Reports
      {
        path: "reports",
        component: AnchorReportLayout,
        beforeEnter: multiguard([isAnchor, isPasswordReset]),
        children: [
          {
            path: "purchases",
            component: PurchasesReport
          },
          {
            path: "invoices",
            component: InvoicesReport
          },
          {
            path: "taxes",
            component: TaxReport
          },
          {
            path: "preapprovedInvoice-report",
            component: PreapprovedInvoiceReport
          }
        ]
      },

      // Data Export
      {
        path: "data-exports",
        component: AnchorDataExportLayout,
        beforeEnter: multiguard([isAnchor, isPasswordReset]),
        children: [
          {
            path: "purchase-Orders",
            component: PurchaseOrderDataExport
          },
          {
            path: "invoices",
            component: InvoiceDataExport
          },
          {
            path: "invoice-detail",
            component: InvoiceDetailDataExport
          },
          {
            path: "payments",
            component: PaymentDataExport
          }
        ]
      },

      {
        path: "settings",
        component: AnchorSettingLayout,
        beforeEnter: multiguard([isAnchor, isPasswordReset]),
        children: [
          {
            path: "user-profile",
            component: AdminProfile
          },
          {
            path: "company-info",
            component: CompanyInfo
          },
          {
            path: "addresses",
            component: Addresses
          },
          {
            path: "contacts",
            component: Contacts
          },
          {
            path: "customization",
            component: Customization
          },
          {
            path: "preferences",
            component: Preferences
          }
        ]
      }
    ]
  },
  /*
   |--------------------------------------------------------------------------
   | Super Admin Backend Routes
   |--------------------------------------------------------------------------|
   */
  {
    path: "/super-admin",
    component: AdminLayoutBasic, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Admin-Dashboard
      {
        path: "/",
        component: SuperAdminDashboard,
        name: "super-admin-dashboard",
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "dashboard",
        component: SuperAdminDashboard,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "backup",
        component: BackupIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },

      // Emails
      {
        path: "emailTemplates",
        component: EmailTemplateIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "emailTemplates/create",
        component: EmailTemplateCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "emailTemplates/:id/edit",
        name: "emailTemplates.edit",
        component: EmailTemplateCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },
      // Reports
      {
        path: "reports",
        component: SuperAdminReportLayout,
        beforeEnter: multiguard([isSuperAdmin]),
        children: [
          {
            path: "preapprovedInvoice-report",
            component: PreapprovedInvoiceReport
          },
          {
            path: "disbursement-report",
            component: DisbursementReport
          },
          {
            path: "payment-report",
            component: PaymentReport
          },
          {
            path: "payment-outstanding-report",
            component: PaymentOutstandingReport
          },
          {
            path: "on-time-payment-report",
            component: OnTimePaymentReport
          },
          {
            path: "payment-receipt-report",
            component: PaymentReciptReport
          }
        ]
      },

      // list of actions
      {
        path: "listOfActions",
        component: ActionIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "emailAction/:id/placeholders",
        component: ActionPlaceholders,
        beforeEnter: multiguard([isSuperAdmin])
      },
      // Finances forms
      {
        path: "finances-forms",
        component: FinancesFormsIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "finances-forms/create",
        component: FinancesFormsCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "finances-forms/:id/view",
        name: "finances-forms.view",
        component: FinancesFunderFormsList,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "finances-forms/:id/edit",
        name: "finances-forms.edit",
        component: FinancesFormsCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },
      // Communication
      {
        path: "communications",
        component: communicationIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "communications/create",
        name: "communications.create",
        component: communicationCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "communications/:id/edit",
        name: "communications.edit",
        component: communicationCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },

      // Accounts

      {
        path: "activities",
        component: PanelInfo,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "accounts",
        component: AccountIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "accounts/create",
        name: "accounts.create",
        component: AccountCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "accounts/:id/edit",
        name: "accounts.edit",
        component: AccountCreate,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "accounts/:id/funder/audit",
        name: "accounts.auditor/accounts",
        component: ConnectAuditorAccount,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "accounts/:id/funder/form",
        name: "accounts.form/accounts",
        component: ConnectFormAccount,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "accounts/:id/view",
        component: AccountView,
        beforeEnter: multiguard([isSuperAdmin]),
        children: [
          {
            path: "basic-info",
            component: AccountBasicInfo
          },
          {
            path: "company-address",
            component: AccountCompanyAddress
          },
          {
            path: "billing-address",
            component: AccountBillingAddress
          },
          {
            path: "shipping-address",
            component: AccountShippingAddress
          },
          {
            path: "business-status",
            component: CustomerBusinessStatus
          },
          {
            path: "borrower-profile",
            component: CustomerBorrowerProfile
          },
          {
            path: "stakeholder",
            component: CustomerStakeholder
          },
          {
            path: "business_financial_institutions",
            component: CustomerBusinessFinancialInstitutions
          },
          {
            path: "financial_facilities",
            component: CustomerFinancialFacilities
          },
          {
            path: "rescheduling_restructuring",
            component: CustomerReschedulingRestructuring
          },
          {
            path: "documents",
            component: CustomerDocuments
          },
          {
            path: "internal-process",
            component: InternalProcess
          },
          {
            path: "customer-process",
            component: CustomerProcess
          },
          {
            path: "processs-documents",
            component: ProcessDocuments
          }
        ]
      },
      // PrePayment
      {
        path: "prepayments/:id/verified",
        component: PrepaymentVerifiedPage,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "preapproved/prepayments/:id/verified",
        component: PrepaymentVerifiedPage,
        name: "preapproved.invoice.verified",
        beforeEnter: multiguard([isSuperAdmin])
      },

      {
        path: "prepayments/:id/request",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "prepayments/:id/updateRequest",
        name: "prepayments.updateRequest.superAdmin",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "prepayments/:id/view",
        component: PrePaymentView,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "preapproved/prepayments/:id/view",
        component: PrePaymentView,
        name: "preapproved-invoice-request-view",
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "prepayments/:id/offer",
        component: PrePaymentOffer,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "preapproved/prepayments/:id/offer",
        component: PrePaymentOffer,
        name: "preapproved.invoice.offer",
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders",
        component: POIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/:id/view",
        component: POView,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/prepayments/:id/view",
        component: POPrePaymentView,
        name: "purchase-order-request-view-funder",
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/prepayments/:id/verified",
        component: POPrepaymentVerifiedPage,
        name: "preapproved.invoice.verified",
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/:id/view",
        component: POView,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/:id/item-status",
        component: POItemStatus,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/:id/attachment",
        component: POAttachment,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/:id/record",
        component: POFinancingActionRecord,
        beforeEnter: multiguard([isSuperAdmin])
      },

      {
        path: "invoices",
        component: InvoiceIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },

      {
        path: "preapproved-invoices",
        component: PreapprovedInvoiceIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },

      {
        path: "bulk-processing",
        component: BulkProcessing,
        beforeEnter: multiguard([isSuperAdmin])
      },

      {
        path: "preapproved-invoices/:id/attachment",
        component: PreapprovedInvoices,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "invoices/:id/view",
        component: InvoiceView,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "invoices/:id/record",
        component: InvoiceActionRecord,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "invoices/:id/attachment",
        component: InvoiceAttachment,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "invoice/:id/funder",
        component: SelectFunder,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "invoice/:id/changePromisedDate",
        component: ChangePromisedDate,
        beforeEnter: multiguard([isSuperAdmin])
      },

      {
        path: "preappoved-invoice/:id/funder",
        component: SelectFunder,
        name: "preapproved-invoice-sendFunder",
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "purchase-orders/:id/funder",
        component: SelectPOFunder,
        name: "purchase-orders-sendFunder",
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "payments",
        name: "superAdmin.payments.index",
        component: PaymentsIndex,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "payments/:id/view",
        component: PaymentView,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "payments/:id/record",
        component: PaymentRecord,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "islamic_finance_forms",
        component: IslamicFinanceFormTemplates,
        beforeEnter: multiguard([isSuperAdmin])
      },
      {
        path: "user-guides",
        component: UserGuideIndex
      },
      {
        path: "user-guides/:id/view",
        component: UserGuideView,
        beforeEnter: multiguard([isSuperAdmin])
      },

      {
        path: "settings",
        component: SuperAdminSettingsLayout,
        beforeEnter: multiguard([isSuperAdmin]),
        children: [
          {
            path: "admin-profile",
            name: "admin.profile",
            component: AdminProfile
          },
          {
            path: "currencies-setting",
            component: CurrencySetting
          },
          {
            path: "document-type-setting",
            component: DocumentTypeSetting
          },
          {
            path: "contacts",
            component: Contacts
          },
          {
            path: "preferences",
            component: Preferences
          }
        ]
      }
    ]
  },
  /*
    |--------------------------------------------------------------------------
    | Supplier Admin Backend Routes
    |--------------------------------------------------------------------------|
    */
  {
    path: "/supplier",
    component: PasswordResetLayout, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Password Change
      {
        path: "password/reset",
        component: PasswordReset,
        beforeEnter: multiguard([isAdmin])
      }
    ]
  },
  {
    path: "/supplier",
    component: LayoutBasic, // Change the desired Layout here
    meta: { requiresAuth: true },
    children: [
      // Dashbord
      {
        path: "/",
        component: Dashboard,
        name: "dashboard",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "user-guides",
        component: UserGuideView,
        name: "admin-default-userGuide",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "user-guides/:id/view",
        component: UserGuideView,
        name: "admin-specfic-userGuide",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "dashboard",
        component: Dashboard,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "offer-to-sell/:id/create",
        component: OfferToSellCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "offer-to-sell/:id/edit",
        component: OfferToSellCreate,
        name: "offer-to-sell.edit",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      // funder
      {
        path: "funders",
        component: FunderIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      {
        path: "funders/:id/islamic_finance",
        component: IslamicFinanceIndex,
        name: "FunderFinance",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "funders/:funder_id/islamic_finance/:id/attachments",
        component: IslamicFinanceAttachment,
        name: "islamicFinanceAttachments",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      {
        path: "funders/:funder_id/islamic_finance/:id/record",
        component: IslamicFinanceRecord,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      {
        path: "funders/:funder_id/islamic_finance/:id/addInvoiceInfo",
        component: IslamicFinanceInvoiceInfo,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "funders/:funder_id/islamic_finance/:id/invoiceVerification",
        component: IslamicFinanceInvoiceVerification,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "funders/:id/view",
        component: FunderView,
        beforeEnter: multiguard([isAdmin, isPasswordReset]),
        children: [
          {
            path: "basic-info",
            component: FunderBasicInfo
          },
          {
            path: "billing-address",
            component: FunderBillingAddress
          },
          {
            path: "shipping-address",
            component: FunderShippingAddress
          },
          {
            path: "credit-limit",
            component: FunderCreditLimit
          }
        ]
      },
      // user management
      {
        path: "user-managements",
        component: UserManagementIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "user-managements/create",
        component: UserManagementCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "user-managements/:id/edit",
        component: UserManagementCreate,
        name: "admin-user-management.edit",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      // Customer
      {
        path: "customers",
        component: CustomerIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "customers/create",
        name: "customers.create",
        component: CustomerCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "customers/:id/edit",
        name: "customers.edit",
        component: CustomerCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "customers/:id/view",
        component: CustomerView,
        beforeEnter: multiguard([isAdmin]),
        children: [
          {
            path: "basic-info",
            component: CustomerBasicInfo
          },
          {
            path: "billing-address",
            component: CustomerBillingAddress
          },
          {
            path: "shipping-address",
            component: CustomerShippingAddress
          }
        ]
      },

      // Items
      {
        path: "items",
        component: ItemsIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "items/create",
        name: "admin.items.create",
        component: ItemCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "items/:id/edit",
        name: "admin.items.edit",
        component: ItemCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      // purchase-orders
      {
        path: "purchase-orders",
        component: POIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/view",
        component: POView,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/attachment",
        component: POAttachment,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/item-status",
        component: POItemStatus,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/discrepency_report",
        component: PODiscrepencyReport,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/record",
        component: POFinancingActionRecord,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "purchase-orders/financing/:id/request",
        component: POFinancingRequest,
        name: "purchase-orders-financing",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "purchase-orders/:id/offer",
        component: POFinancingOfferPage,
        name: "purchase-orders.offer",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      // delivery not
      {
        path: "delivery-notes",
        name: "deliveryNotes.index",
        component: DeliveryNoteIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "delivery-notes/create",
        name: "delivery-notes.create",
        component: DeliveryNoteCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "delivery-notes/:id/edit",
        name: "delivery-notes.edit",
        component: DeliveryNoteCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "manually-delivery-notes/:id/edit",
        name: "manually-delivery-notes.edit",
        component: ManualDeliveryNoteCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "delivery-notes/:id/view",
        component: DeliveryNoteView,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      // Estimate
      {
        path: "estimates",
        name: "estimates.index",
        component: EstimateIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "estimates/create",
        name: "estimates.create",
        component: EstimateCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "estimates/:id/view",
        name: "estimates.view",
        component: EstimateView,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "estimates/:id/edit",
        name: "estimates.edit",
        component: EstimateCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "preapproved-invoices",
        component: PreapprovedInvoiceIndex,
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "preapproved-invoices/:id/attachment",
        component: PreapprovedInvoices,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "preapproved-invoice/prepayments/:id/request",
        component: PrePaymentRequest,
        name: "preapproved-invoice-request",
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      // Invoice
      {
        path: "invoices",
        name: "invoices.index",
        component: InvoiceIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "invoices/create",
        name: "invoices.create",
        component: InvoiceCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "invoices/:id/view",
        component: InvoiceView,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "invoices/:id/record",
        component: InvoiceActionRecord,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "invoices/:id/edit",
        name: "invoices.edit",
        component: InvoiceCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      {
        path: "manually-invoices/:id/edit",
        name: "manually-invoices.edit",
        component: ManualInvoiceCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      {
        path: "invoices/:id/attachment",
        component: InvoiceAttachment,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "invoices/:id/discrepency_report",
        component: InvoiceDiscrepencyReport,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      // Payments
      {
        path: "payments",
        name: "admin.payments.index",
        component: PaymentsIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "payments/:id/record",
        component: PaymentRecord,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "payments/create",
        component: AdminPaymentCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "payments/:id/payment/create",
        name: "payments.payment.create",
        component: AdminPaymentCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "payments/:id/settlement/create",
        name: "payments.settlement.create.admin",
        component: AdminPaymentCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      // {
      //   path: 'payments/create',
      //   name: 'payments.create',
      //   component: PaymentCreate,
      //   beforeEnter: multiguard([isAdmin,isPasswordReset])
      // },
      // {
      //   path: 'payments/:id/create',
      //   name: 'admin.invoice.payments.create',
      //   component: PaymentCreate,
      //   beforeEnter: multiguard([isAdmin,isPasswordReset])
      // },

      // {
      //   path: 'payments/:id/edit',
      //   name: 'payments.edit',
      //   component: PaymentCreate,
      //   beforeEnter: multiguard([isAdmin,isPasswordReset])
      // },
      {
        path: "payments/:id/view",
        name: "payments.view",
        component: PaymentView,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      // PrePayment
      {
        path: "prepayments/:id/request",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "prepayments/:id/updateRequest",
        name: "prepayments.updateRequest.admin",
        component: PrePaymentRequest,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "prepayments/:id/view",
        component: PrePaymentView,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "preapproved/prepayments/:id/view",
        component: PrePaymentView,
        name: "preapproved-invoice-request-view-supplier",
        beforeEnter: multiguard([isAdmin])
      },
      {
        path: "prepayments/:id/offer",
        component: PrePaymentOffer,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "preapproved/prepayments/:id/offer",
        component: PrePaymentOffer,
        name: "preapproved.invoice.offer",
        beforeEnter: multiguard([isAdmin])
      },
      // Expenses
      {
        path: "expenses",
        component: ExpensesIndex,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "expenses/create",
        name: "expenses.create",
        component: ExpenseCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },
      {
        path: "expenses/:id/edit",
        name: "expenses.edit",
        component: ExpenseCreate,
        beforeEnter: multiguard([isAdmin, isPasswordReset])
      },

      // Reports
      {
        path: "reports",
        component: ReportLayout,
        beforeEnter: multiguard([isAdmin, isPasswordReset]),
        children: [
          {
            path: "sales",
            component: SalesReport
          },
          {
            path: "sales-data",
            component: SalesDataReport
          },
          {
            path: "expenses",
            component: ExpensesReport
          },
          {
            path: "profit-loss",
            component: ProfitLossReport
          },
          {
            path: "taxes",
            component: TaxReport
          },
          {
            path: "invoice-report",
            component: InvoiceReport
          },
          {
            path: "preapprovedInvoice-report",
            component: PreapprovedInvoiceReport
          },
          {
            path: "payment-outstanding-report",
            component: PaymentOutstandingReport
          },
          {
            path: "approved-finance",
            component: ApprovedFinanceReport
          }
        ]
      },

      // Data Export
      {
        path: "data-exports",
        component: DataExportLayout,
        beforeEnter: multiguard([isAdmin, isPasswordReset]),
        children: [
          {
            path: "purchase-Orders",
            component: PurchaseOrderDataExport
          },
          {
            path: "invoices",
            component: InvoiceDataExport
          },
          {
            path: "invoice-detail",
            component: InvoiceDetailDataExport
          },

          {
            path: "payments",
            component: PaymentDataExport
          }
        ]
      },

      // Settings
      {
        path: "settings",
        component: SettingsLayout,
        beforeEnter: multiguard([isAdmin]),
        children: [
          {
            path: "company-info",
            component: CompanyInfo
          },
          {
            path: "addresses",
            component: Addresses
          },
          {
            path: "contacts",
            component: Contacts
          },
          {
            path: "customization",
            name: "customization",
            component: Customization
          },
          {
            path: "user-profile",
            component: UserProfile
          },
          {
            path: "preferences",
            name: "preferences",
            component: Preferences
          },
          {
            path: "tax-types",
            name: "tax.types",
            component: TaxTypes
          },
          {
            path: "expense-category",
            name: "expense.category",
            component: ExpenseCategory
          },
          {
            path: "mail-configuration",
            name: "mailconfig",
            component: MailConfig
          },
          {
            path: "notifications",
            name: "notifications",
            component: Notifications
          },
          {
            path: "update-app",
            name: "updateapp",
            component: UpdateApp
          }
        ]
      },
      {
        path: "profile",
        component: ProfileLayout,
        beforeEnter: multiguard([isAdmin]),
        children: [
          {
            path: "business-status",
            name: "business.status",
            component: BusinessStatus
          },
          {
            path: "borrower-profile",
            name: "borrower.profile",
            component: BorrowerProfile
          },
          {
            path: "nature_business",
            name: "nature.business",
            component: BusinessNature
          },
          {
            path: "stakeholder",
            name: "stakeholder",
            component: stakeholder
          },
          {
            path: "business_financial_institutions",
            name: "business.financial.institutions",
            component: BusinessFinancialInstitutions
          },
          {
            path: "financial_facilities",
            name: "financial.facilities",
            component: FinancialFacilities
          },
          {
            path: "rescheduling_restructuring",
            name: "rescheduling.restructuring",
            component: ReschedulingRestructuring
          },
          {
            path: "documents",
            name: "documents",
            component: Documents
          },
          {
            path: "sharing_profile_code",
            name: "sharing.profile.code",
            component: SharingProfileCode
          }
        ]
      }
    ]
  },

  //  DEFAULT ROUTE
  { path: "*", component: NotFoundPage }
];

const router = new VueRouter({
  routes,
  mode: "history",
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
  var timeout = 1000 * 60 * 15; // Makes 15 minutes in nanoseconds
  //  Redirect if not authenticated on secured routes
  if (to.matched.some(m => m.meta.requiresAuth)) {
    if (!store.getters["auth/isAuthenticated"]) {
      return next("/login");
    }
  }

  if (
    to.matched.some(m => m.meta.redirectIfAuthenticated) &&
    store.getters["auth/isAuthenticated"]
  ) {
    if (localStorage.getItem("account_type") === "admin") {
      // return next('/admin/dashboard')
      return next("/supplier/dashboard");
    }
    if (localStorage.getItem("account_type") === "anchor") {
      return next("/anchor/dashboard");
    }
    if (localStorage.getItem("account_type") === "funder") {
      return next("/funder/dashboard");
    }
    if (localStorage.getItem("account_type") === "auditor") {
      return next("/auditor/islamic-finances");
    }
    if (localStorage.getItem("role") === "super_admin") {
      return next("/super-admin/dashboard");
    }
  }
  var isLocalStorageSet = localStorage.getItem("lastActivityTime");
  if (isLocalStorageSet == null) {
    localStorage.setItem("lastActivityTime", Date.now());
  } else if (Date.now() - localStorage.getItem("lastActivityTime") > timeout) {
    localStorage.removeItem("lastActivityTime");
    if (store.getters["auth/isAuthenticated"]) {
      store.dispatch("auth/logout");
    }
  } else {
    localStorage.setItem("lastActivityTime", Date.now());
  }
  return next();
});

export default router;
